import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { CanDeactivateGuard } from './can-deactivate.guard';
import { ApplicationStatus } from './models/user.model';
import { AnalyzeComponent } from './views/analyze/analyze.component';
import { FaqComponent } from './views/faq/faq.component';
import { HistoryComponent } from './views/history/history.component';
import { HomeComponent } from './views/home/home.component';
import { LoginComponent } from './views/login/login.component';
import { NominateComponent } from './views/nominate/nominate.component';
import { ProfileComponent } from './views/profile/profile.component';
import { RankComponent } from './views/rank/rank.component';
import { ContactComponent } from './views/contact/contact.component';
import { ReviewApplicantsComponent } from './views/reviewapplicants/reviewapplicants.component';
import { ReviewPublicDataComponent } from './views/reviewpublicdata/reviewpublicdata.component';
import { ReviewRoomsComponent } from './views/reviewrooms/reviewrooms.component';
import { SolutionComponent } from './views/solution/solution.component';
import { ValidateComponent } from './views/validate/validate.component';

/* eslint-disable no-multi-spaces */
const voterPortalRoutes: Routes = [
  { path: 'login',    component: LoginComponent,    canActivate: [AuthGuard] },
  { path: 'faq',      component: FaqComponent },
  { path: 'contact',  component: ContactComponent },
  { path: 'venerate', component: SolutionComponent },
  { path: '',         component: HomeComponent,     canActivate: [AuthGuard] },
  { path: 'review-applicants', component: ReviewApplicantsComponent,  canActivate: [AuthGuard],
    data: { status: ApplicationStatus.REVIEWER, allowOwner: true } },
  { path: 'approve',  redirectTo: '/review-applicants', pathMatch: 'full' },
  { path: 'review-rooms',    component: ReviewRoomsComponent, canActivate: [AuthGuard], data: { status: ApplicationStatus.REVIEWER } },
  { path: 'match',    redirectTo: '/review-rooms',  pathMatch: 'full' },
  { path: 'nominate', component: NominateComponent, canActivate: [AuthGuard], data: { status: ApplicationStatus.NOMINATOR } },
  { path: 'rank',     component: RankComponent,     canActivate: [AuthGuard], data: { status: ApplicationStatus.VOTER } },
  { path: 'review-public-data',   component: ReviewPublicDataComponent, canActivate: [AuthGuard], data: { status: ApplicationStatus.VOTER } },
  { path: 'review',   redirectTo: '/review-public-data',    pathMatch: 'full' },
  { path: 'validate', component: ValidateComponent, canActivate: [AuthGuard], data: { status: ApplicationStatus.APPROVER } },
  { path: 'analyze',  component: AnalyzeComponent,  canActivate: [AuthGuard],
    data: { status: ApplicationStatus.APPROVER, allowResultsAccess: true } },
  { path: 'history',  component: HistoryComponent,  canActivate: [AuthGuard], data: { status: ApplicationStatus.VOTER } },
  { path: 'profile',  component: ProfileComponent,  canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard],
    data: { status: ApplicationStatus.VOTER } },
  { path: '**',       redirectTo: '' },
];

/* eslint-enable */

@NgModule({
  imports: [RouterModule.forRoot(voterPortalRoutes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
